import { useEffect } from 'react';

interface UseEscapeKeyClearParams {
  hasPlanningSelection: boolean;
  hasSelectionDrag: boolean;
  hasEntitySelection: boolean;
  hasMultiSelection: boolean;
  clearPlanningSelection: () => void;
  clearSelectionDrag: () => void;
  clearEntitySelection: () => void;
  clearMultiSelection: () => void;
}

export const useEscapeKeyClear = ({
  hasPlanningSelection,
  hasSelectionDrag,
  hasEntitySelection,
  hasMultiSelection,
  clearPlanningSelection,
  clearSelectionDrag,
  clearEntitySelection,
  clearMultiSelection,
}: UseEscapeKeyClearParams) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;

      if (hasPlanningSelection) {
        e.preventDefault();
        clearPlanningSelection();
        return;
      }
      if (hasSelectionDrag) {
        clearSelectionDrag();
        return;
      }
      if (hasEntitySelection) {
        e.preventDefault();
        clearEntitySelection();
        return;
      }
      if (hasMultiSelection) {
        e.preventDefault();
        clearMultiSelection();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    hasPlanningSelection,
    hasSelectionDrag,
    hasEntitySelection,
    hasMultiSelection,
    clearPlanningSelection,
    clearSelectionDrag,
    clearEntitySelection,
    clearMultiSelection,
  ]);
};
